export default __webpack_public_path__ + "static/media/team10.7040bdb7.JPG";